const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59998 4.00002C1.59998 3.11637 2.31632 2.40002 3.19998 2.40002H12.8C13.6836 2.40002 14.4 3.11637 14.4 4.00002V12C14.4 12.8837 13.6836 13.6 12.8 13.6H3.19998C2.31632 13.6 1.59998 12.8837 1.59998 12V4.00002ZM4.23429 5.03434C4.54671 4.72192 5.05324 4.72192 5.36566 5.03434L7.76566 7.43434C8.07808 7.74676 8.07808 8.25329 7.76566 8.56571L5.36566 10.9657C5.05324 11.2781 4.54671 11.2781 4.23429 10.9657C3.92187 10.6533 3.92187 10.1468 4.23429 9.83434L6.0686 8.00002L4.23429 6.16571C3.92187 5.85329 3.92187 5.34676 4.23429 5.03434ZM8.79998 9.60003C8.35815 9.60003 7.99998 9.9582 7.99998 10.4C7.99998 10.8419 8.35815 11.2 8.79998 11.2H11.2C11.6418 11.2 12 10.8419 12 10.4C12 9.9582 11.6418 9.60003 11.2 9.60003H8.79998Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.2bb3fbffce18341ccd3e25413cbb27e5.svg";
export { ForwardRef as ReactComponent };